import { FilterSections, FilterDefinition } from '../../types/content/filter.types';

export const mapDefinitions = (sections: FilterSections[]): FilterDefinition[] => {
  const mappedDefinitions = [];
  sections.forEach(section => {
    mappedDefinitions.push(section.ungrouped?.definitions);
    section.grouped?.forEach(group => {
      mappedDefinitions.push(group.definitions);
    });
  });
  return mappedDefinitions.flat();
};
